import React, { useMemo, useRef } from 'react';
import { LineWrapperProp, SplitText } from '@cyriacbr/react-split-text';
import { LineByLineInterface } from './line-by-line.interface';
import styles from './line-by-line.module.css';
import useIntersection from '../../hooks/use-intersection';
import classNames from 'classnames';

const LineByLine: React.FunctionComponent<LineByLineInterface> = ({
  text,
}) => {
  const componentRef = useRef() as React.MutableRefObject<HTMLParagraphElement>;
  const isComponentInView = useIntersection({
    ref: componentRef,
    options: {
      rootMargin: '-50px',
    },
  });

  const LineWrapper: React.FC<LineWrapperProp> = ({
    lineIndex,
    children,
  }) => {
    return (
      <span
        key={lineIndex}
        className={styles.line}
        style={{
          '--line-index': lineIndex,
        } as React.CSSProperties}
        children={children}
      />
    );
  };

  const MemoizedLineWrapper = useMemo(() => LineWrapper, []);

  return (
    <span
      ref={componentRef}
      className={classNames(
        styles.component,
        {
          [styles.isInViewport]: isComponentInView,
        },
      )}
    >
      <SplitText
        LineWrapper={MemoizedLineWrapper}
        children={text}
      />
    </span>
  );
};

export default LineByLine;
